import { useI18n } from '../../../i18n';
// ============================================
// PromotionStatsRow Component
// ============================================

interface StatsCardProps {
  title: string;
  value: React.ReactNode;
  color: string;
}

function StatsCard({ title, value, color }: StatsCardProps) {
  return (
    <div className="rounded-xl border border-slate-100 bg-white p-5 shadow-sm">
      <p className="text-xs font-medium uppercase tracking-wider text-[#666]">{title}</p>
      <p className={`mt-2 text-xl leading-8 font-bold sm:text-[32px] sm:leading-[40px] ${color}`}>{value}</p>
    </div>
  );
}

export interface PromotionStats {
  total: number;
  active: number;
  expired: number;
  percentage: number;
  fixedAmount: number;
}

export function PromotionStatsRow({ stats }: { stats: PromotionStats }) {
  const { t } = useI18n();
  return (
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-5">
      <StatsCard title={t('promotionsTotal')} value={stats.total} color="text-[#0288D1]" />
      <StatsCard title={t('promotionsActive')} value={stats.active} color="text-[#219653]" />
      <StatsCard title={t('expired')} value={stats.expired} color="text-[#FA7070]" />
      {/* Bug #136: hai thẻ này trước đây ghi trống lốc "Percentage" và "Fixed
          Amount" — đứng cạnh Total/Active/Expired (đều là SỐ LƯỢNG promotion)
          thì người đọc không biết đó là số promotion hay là một tỉ lệ phần trăm
          nào đó. Nhãn nay nói rõ đang đếm promotion theo KIỂU GIẢM GIÁ. */}
      <StatsCard title={t('promotionsPercentageCount')} value={stats.percentage} color="text-[#D946EF]" />
      <StatsCard title={t('promotionsFixedAmountCount')} value={stats.fixedAmount} color="text-[#F59E0B]" />
    </div>
  );
}
